import { render, staticRenderFns } from "./ScreeningProgressCardActions.vue?vue&type=template&id=0c6120e8&scoped=true&"
import script from "./ScreeningProgressCardActions.vue?vue&type=script&lang=js&"
export * from "./ScreeningProgressCardActions.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningProgressCardActions.vue?vue&type=style&index=0&id=0c6120e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6120e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
